import {
  breakpointSizes,
  getBreakpointOnly,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface LoadingBoxBottomProps {
  className?: string
}

const LoadingBoxBottom: React.FC<
  React.PropsWithChildren<LoadingBoxBottomProps>
> = (props): React.ReactElement => {
  const translate = useTranslate()

  return (
    <div
      className={props.className}
      data-testid={'loading'}
      css={css`
        display: flex;
        justify-content: center;
        padding: 20px ${styleConstants.widths.cardPaddingXSMUp};

        ${getBreakpointOnly(breakpointSizes.XXSM)(css`
          padding: 20px ${styleConstants.widths.cardPaddingXXSMOnly};
        `)}
      `}
    >
      <span
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.cta,
            styleConstants.fontFamilies.medium,
          )}
        `}
      >
        {translate('Loading...')}
      </span>
    </div>
  )
}

export default LoadingBoxBottom
